import React from 'react';

interface BridgeBankLogoProps {
  width?: number;
  height?: number;
  className?: string;
}

const BridgeBankLogo: React.FC<BridgeBankLogoProps> = ({
  width = 200,
  height = 60,
  className
}) => {
  const iconSize = height * 0.85;
  return (
    <div className={className} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      {/* Generic Credit Scoring Platform Icon */}
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Outer shield shape */}
        <path
          d="M40 6 L68 18 L68 42 C68 58 55 70 40 74 C25 70 12 58 12 42 L12 18 Z"
          fill="#1565c0"
          opacity="0.15"
        />
        <path
          d="M40 10 L64 21 L64 42 C64 56 53 67 40 70 C27 67 16 56 16 42 L16 21 Z"
          fill="none"
          stroke="#1565c0"
          strokeWidth="2.5"
        />
        {/* Bar chart inside shield representing scoring */}
        <rect x="24" y="50" width="7" height="10" rx="1.5" fill="#42a5f5" />
        <rect x="34" y="40" width="7" height="20" rx="1.5" fill="#1976d2" />
        <rect x="44" y="32" width="7" height="28" rx="1.5" fill="#1565c0" />
        {/* Upward trend arrow */}
        <polyline
          points="24,48 34,38 44,30 56,22"
          stroke="#00acc1"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <polygon points="56,22 50,24 54,30" fill="#00acc1" />
      </svg>

      {/* Text */}
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{
          fontSize: height * 0.38,
          fontWeight: 800,
          color: '#FFFFFF',
          letterSpacing: '1.5px',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          lineHeight: 1.1
        }}>
          FinScore
        </div>
        <div style={{
          fontSize: height * 0.18,
          fontWeight: 500,
          color: '#00acc1',
          letterSpacing: '2.5px',
          marginTop: 1,
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          textTransform: 'uppercase'
        }}>
          AI Platform
        </div>
      </div>
    </div>
  );
};

export default BridgeBankLogo;
